import { useEffect } from 'react';
import { usePrevious } from './use-previous';
export function useFocusWhen(fn, focusableElement) {
    const val = fn();
    const previousVal = usePrevious(val);
    useEffect(()=>{
        if (val && previousVal === false) {
            focusableElement?.current?.focus();
        }
    }, [
        val,
        previousVal,
        focusableElement
    ]);
}

//# sourceMappingURL=use-focus-when.js.map